import { notification } from 'antd';

notification.config({
    top: 100, // Adjust this value to move it lower
});

export const _getUrlParams = function() {
    const query = new URLSearchParams( window.location.search );

	const param = {};
	for ( const key of query.keys() ) {
		param[key] = query.get( key );
	}
	return param;
};

export const openNotification = (type, message, description) => {
	notification[type]({
	  message: message,
	  description: description,
	  placement: 'topRight', // Options: 'topLeft', 'topRight', 'bottomLeft', 'bottomRight'
	  duration: 3,          // Duration in seconds (set to 0 for persistent)
	});
};
